import { ExternalLink } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { HackerSponsorsKapso } from '@/types';

// /:event_slug/hacker/kapso and /26-ar/kapso — the three twins as one page (PORTING.md
// G5). Argentina sets the display face on every heading.
export default function Kapso({
  creditUrl,
  subtitle,
  titleFont,
}: HackerSponsorsKapso) {
  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 py-12 md:py-16">
        <div className="mx-auto w-full max-w-4xl space-y-8">
          <div className="text-center">
            <h1
              className={cn(
                'inline-block font-bold text-2xl text-primary sm:text-3xl md:text-4xl',
                titleFont,
              )}
            >
              <span className="bg-primary px-2 py-1 text-background">
                KAPSO
              </span>
            </h1>
            <p
              className={cn(
                'mt-4 text-primary/70 text-sm uppercase tracking-wide',
                titleFont,
              )}
            >
              {subtitle}
            </p>
          </div>

          <div className="border-2 border-primary bg-background/80 p-6 backdrop-blur-sm sm:p-8 md:p-10">
            <div className="space-y-6">
              <div className="border-primary/20 border-b pb-4">
                <h2
                  className={cn(
                    'font-bold text-2xl text-primary sm:text-3xl md:text-4xl',
                    titleFont,
                  )}
                >
                  CRÉDITO DEL EQUIPO
                </h2>
                <p className={cn('mt-2 text-primary/70 text-sm', titleFont)}>
                  Cada equipo recibe USD 20 en créditos de Kapso.
                </p>
              </div>

              {creditUrl ? (
                <>
                  <div className="border-primary border-l-4 pl-4">
                    <h3
                      className={cn(
                        'font-bold text-primary/70 text-sm uppercase',
                        titleFont,
                      )}
                    >
                      Link de canje del equipo
                    </h3>
                    <p className="break-all font-mono text-primary text-sm sm:text-base">
                      {creditUrl}
                    </p>
                  </div>

                  <a
                    href={creditUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={cn(
                      'inline-flex items-center gap-2 border-2 border-primary bg-primary px-6 py-3 font-bold text-background uppercase tracking-wide transition-all hover:bg-background hover:text-primary',
                      titleFont,
                    )}
                  >
                    Canjear crédito
                    <ExternalLink className="h-4 w-4" />
                  </a>
                </>
              ) : (
                <div className="border-primary border-l-4 pl-4">
                  <p className={cn('text-primary/70 text-sm', titleFont)}>
                    Aún no hay un crédito de Kapso asignado a tu equipo. Si
                    crees que esto es un error, avisanos en Discord.
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
